import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/SlidersHorizontal.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...e, weights: i }));
r.displayName = "SlidersHorizontalIcon";
const l = r;
export {
  l as SlidersHorizontal,
  r as SlidersHorizontalIcon
};
